/**
 * 应用入口：必须先于 main.jsx 整棵静态 import 树执行 webkit 兜底，
 * 否则 iOS 内嵌浏览器（FB / Instagram / TikTok 等 IAB）下第三方脚本可能在守卫之前访问 window.webkit.messageHandlers。
 */
import { installWebkitBridgeGuard } from './utils/webkitBridgeGuard'

installWebkitBridgeGuard()

/** 与 main 并行下载阅读页 chunk，缩短 lazy + Suspense 带来的瀑布（pathname 路由，见 App.jsx） */
if (typeof location !== 'undefined') {
  const pathOnly = (location.pathname || '/').split('?')[0] || '/'
  const warmContinuousRead =
    /^\/novel\/[^/]+\/chapter\/[^/]+\/?$/.test(pathOnly) || /^\/read\/[^/]+\/?$/.test(pathOnly)
  if (warmContinuousRead) {
    import('./pages/novel/preview/NovelContinuousReadPage.jsx').catch(() => {})
  }
}

import('./main.jsx').catch((err) => {
  console.error('[entry] bootstrap main failed', err)
})
